import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { APIClient } from "../../helpers/api_helper";
import { Spinner } from "reactstrap";

const apiClient = new APIClient();

const formatDate = (dateStr) => {
  if (!dateStr) return "—";
  return new Date(dateStr).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const formatAmount = (amount) => {
  if (amount == null || amount === "") return "0.00";
  const num = parseFloat(amount);
  return Number.isNaN(num)
    ? "0.00"
    : "₹" +
        num.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
};

const getPartyName = (row) => row?.invoiceParty?.name ?? row?.invoice?.party?.name ?? "—";
const getInvoiceNo = (row) => row?.invoice?.invoiceNo ?? "—";
const getSubtype = (row) =>
  row?.invoice?.invoiceSubtype?.description ?? row?.invoice?.invoiceSubtype?.subtype ?? "—";

const RecentExpenses = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await apiClient.get("/dashboard/recent-expenses", { limit: 10 });
        const raw = response?.data ?? response;
        setData(Array.isArray(raw) ? raw : []);
      } catch (err) {
        setError(err?.message || "Failed to load recent expenses");
        setData([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <Col xl={8}>
        <Card>
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Recent Expenses</h4>
          </CardHeader>
          <CardBody className="text-center py-5">
            <Spinner color="primary" />
          </CardBody>
        </Card>
      </Col>
    );
  }

  return (
    <Col xl={8}>
      <Card>
        <CardHeader>
          <h4 className="card-title mb-0">Recent Expenses</h4>
        </CardHeader>
        <CardBody>
          {error ? (
            <div className="alert alert-danger mb-0">{error}</div>
          ) : (
            <div className="table-responsive table-card">
              <table className="table table-borderless table-centered align-middle table-nowrap mb-0">
                <thead className="text-muted table-light">
                  <tr>
                    <th scope="col">Invoice No</th>
                    <th scope="col">Date</th>
                    <th scope="col">Party</th>
                    <th scope="col">Category</th>
                    <th scope="col">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {(data || []).map((row) => (
                    <tr key={row.id}>
                      <td>
                        <span className="fw-medium text-body">{getInvoiceNo(row)}</span>
                      </td>
                      <td>{formatDate(row.createdAt)}</td>
                      <td>{getPartyName(row)}</td>
                      <td>{getSubtype(row)}</td>
                      <td>
                        <span className="text-danger fw-medium">{formatAmount(row.debitAmount)}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default RecentExpenses;
